<template>
    <div class="mainbox">
        <div v-if="availableRates && Object.keys(availableRates).length > 1">
            <div class="floatleft marginright10">
                <h4 style="margin-top: 10%;">Tarief code:</h4>
            </div>
            <div class="floatleft marginright15">
                <div class="select-drop">
                    <select
                        :disabled="!availabilityReceived"
                        v-model="rateCode"
                        v-on:change="getData"
                    >
                        <option value="" disabled>Kies een tarief</option>
                        <option
                            v-for="(rate, index) in Object.keys(availableRates)"
                            :key="'AvailableRates' + index"
                            :value="cruise.rederij_id == 16 ? availableRates[rate] : rate "
                        >
                            {{ rate }} - {{ availableRates[rate] }}
                        </option>
                    </select>
                </div>
                <div v-if="cruise.rederij_id == 20" class="regel marginbottom5 borderbottom lineheight32 height32" style="align-items: center; display: flex;">
                  <div class="marginright5 floatleft">
                    Fooien/Services:
                  </div>
                  <div class="variabel width80 floatleft">
                    <input type="radio" :checked="!feeUsed"  v-on:change="toggleFee(false)" class="marginright5" name="fooien" id="fooien_ex">
                    <label for="fooien_ex">&nbsp;Prijzen zonder fooien</label>
                    <input type="radio" :checked="feeUsed" v-on:change="toggleFee(true)" class="marginright5 marginleft15" name="fooien" id="fooien_inc">
                    <label for="fooien_inc">&nbsp;Prijzen met fooien</label>
                  </div>
                </div>
            </div>
        </div>

        <div class="floatleft marginright10">
            <h4 style="margin-top: 10%;">Filter op hut type:</h4>
        </div>
        <div class="floatleft marginright15">
            <div class="select-drop">
                <select v-model="selectedType">
                    <option value="all">Alle types</option>
                    <option
                        v-for="(cabinType, index) in cabinTypes"
                        :key="'CabinTypeSelect' + index"
                        :value="cabinType.text"
                    >
                        {{ cabinType.text }}
                    </option>
                </select>
            </div>
        </div>

        <div class="floatright marginleft10">
            <div v-if="response && response.error">
                Fouten: {{ response.messages }}
            </div>

            <span>{{ cruise.rederij_naam }}</span>
            <span v-if="cabinPaxObj !== {}">
                - passagiers: {{ cabinPaxObj }} - KinderLeeftijden:
                {{ kinderLeeftijden }}
            </span>
            <span v-if="ajaxCalls > 0">
                - Op te vragen prijzen: {{ ajaxCalls }}</span
            >
        </div>
        <div class="clear"></div>

        <div class="deckmapoverlay" id="deckmapview">
            <DeckMapView
                v-show="showDeckMap"
                :toggleDeckMap="toggleDeckMap"
                :cabinNumbers="cabinNumbers"
                :deckMap="deckMap"
                :deckMapReceived="deckMapReceived"
                :showDeckMap="showDeckMap"
            />
        </div>

        <div v-if="isSaved" class="succes">
            <h2>
                Opgeslagen in dossier. Je kunt dit venster nu sluiten.
            </h2>
        </div>

        <div class="clear"></div>

        <table v-if="waitingCompleted" class="table" style="font-size: 115%">
            <tr style="color: black;" class="border_bottom">
                <th>
                    Hutnaam
                </th>
                <th>
                    Code
                </th>
                <th>
                    Rate
                    <!--     Spacer       -->
                    <div style="display: inline-grid; width: 260px;"></div>
                    Prijs p.p.
                    <!--     Spacer       -->
                    <div style="display: inline-grid; width: 15px;"></div>
                    Prijs
                </th>

                <td></td>
            </tr>

            <tr
                v-for="(cabin, index) in sortedCabins"
                :key="'SortedCabins' + index"
            >
                <td>
                    {{ cabin.naam }}
                </td>
                <td>
                    {{ cabin.code }}
                </td>
                <td colspan="12">
                    <table class="innertable">
                        <tr
                            v-for="(apiData, index) in cabin.apiData"
                            :key="'CabinApiData' + index"
                        >
                            <td style="width: 300px;">
                                {{ apiData.rateCode }} - {{ apiData.rateName }}
                            </td>
                            <td style="width: 75px;">
                                € {{ payload.fooien_requested === 'true' && cruise.rederij_id === 20 && typeof apiData.fooiprijs !== undefined && Number(apiData.fooiprijs) > 0 ? prijsPP(Number(apiData.prijs) + Number(apiData.fooiprijs)) : prijsPP(apiData.prijs) }}
                            </td>
                            <td
                                style="width: 70px;"
                                v-on:click="togglePrices()"
                            >
                                <u>€ {{ payload.fooien_requested === 'true' && cruise.rederij_id === 20 && typeof apiData.fooiprijs !== undefined && Number(apiData.fooiprijs) > 0 ? Number(apiData.prijs) + Number(apiData.fooiprijs) : apiData.prijs }}</u>
                                <div v-if="!isHidden && apiData.priceBreakDown">
                                    <div
                                        v-for="(price,
                                        index) in apiData.priceBreakDown"
                                        :key="'ApiDataPriceBreakDown' + index"
                                    >
                                        &euro; {{ price }},-
                                    </div>
                                </div>
                            </td>
                            <td>
                                <button
                                    :enabled="apiData.prijs > 0"
                                    :disabled="ajaxCalls !== 0"
                                    v-on:click="selectCabin(cabin, apiData)"
                                >
                                    <span v-if="isSelectedCabin(apiData.id)">
                                        Geselecteerd
                                    </span>
                                    <span v-else="">
                                        Selecteer
                                    </span>

                                    <span v-if="ajaxCalls !== 0">
                                        <font-awesome-icon
                                            icon="spinner"
                                            :spin="true"
                                        />
                                        {{ ajaxCalls }}
                                    </span>
                                </button>
                            </td>
                            <td>
                                <span v-if="isSelectedCabin(cabin.id)">
                                    Kies hutnummer:
                                    <div class="select-drop">
                                        <select
                                            :disabled="!availabilityReceived"
                                            v-model="cabinNumbers.selected"
                                        >
                                            <option value=""
                                                >Geen hutnummer</option
                                            >
                                            <option
                                                v-for="(cabinNumber,
                                                index) in cabinNumbers.options"
                                                :key="
                                                    'CabinNumbersOptions' +
                                                        index
                                                "
                                                :value="cabinNumber"
                                            >
                                                {{ cabinNumber }}
                                            </option>
                                        </select>
                                    </div>

                                    <button v-on:click="toggleDeckMap()">
                                        Bekijk dek
                                    </button>

                                    <div v-if="isSaved" class="succes">
                                        Opgeslagen in dossier.
                                    </div>

                                    <button
                                        v-if="!isSaved"
                                        v-on:click="
                                            saveSelectedCabin(cabin, apiData)
                                        "
                                    >
                                        Hut Opslaan in Dossier
                                    </button>
                                </span>
                            </td>
                        </tr>
                    </table>
                </td>
            </tr>
        </table>

        <div
            v-if="waiting"
            class="row paddingleft15 paddingright15 paddingtop20"
            style="text-align: center; font-size:50px;"
        >
            <font-awesome-icon icon="spinner" :spin="true" />
        </div>

        <div v-if="!waiting && availabilityReceived && !filteredCabins">
            <h2 style="color:black">
                Geen resultaten...
            </h2>
        </div>
    </div>
</template>

<script>
import DeckMapView from './components/DeckMap.vue'
export default {
    name: 'CabinFinder.vue',
    data: function() {
        return {
            count: 0,
            selectedType: 'all',
            rateCode: null,
            message: 'Selecteer',
            selectedId: 0,
            isSaved: false,
            isHidden: true,
            showDeckMap: false,
            deckMapReceived: false,
        }
    },
    components: {
        DeckMapView,
    },
    computed: {
        feeUsed: function() {
          return this.$store.state.payload.fooien_requested != 'false'
        },
        sortedCabins: function() {
            let selectedType = this.selectedType
            if (!Array.isArray(this.cabins)) {
                return []
            }

            return this.cabins
                .filter(function(cabin) {
                    let isResultDoneFilter =
                        cabin.apiData && cabin.apiData.length > 0
                    if (selectedType === 'all') {
                        return isResultDoneFilter
                    }
                    return (cabin.type === selectedType) & isResultDoneFilter
                })
                .sort(function(cabinA, cabinB) {
                    let priceA = 0
                    let priceB = 0

                    if (
                        cabinA.apiData &&
                        cabinA.apiData[0] &&
                        cabinA.apiData[0].prijs > 0
                    ) {
                        priceA = cabinA.apiData[0].prijs
                    }

                    if (
                        cabinB.apiData &&
                        cabinB.apiData[0] &&
                        cabinB.apiData[0].prijs > 0
                    ) {
                        priceB = cabinB.apiData[0].prijs
                    }

                    if (priceA === 0) {
                        return 10000
                    }
                    if (priceB === 0) {
                        return -10000
                    }
                    return priceA - priceB
                })
        },
        deckMap: function() {
            return this.$store.state.deckMap
        },
        dossierID: function() {
            return parseInt(this.$route.params.dossierID)
        },
        cabinIndex: function() {
            return parseInt(this.$route.params.cabinIndex)
        },
        waiting: function() {
            return this.$store.state.waiting
        },
        ajaxCalls: function() {
            return this.$store.state.ajaxCalls
        },
        availabilityReceived: function() {
            return this.$store.state.availabilityReceived
        },
        availableRates: function() {
            return this.$store.state.availableRates
        },
        cabinTypes: function() {
            return this.$store.state.cabinTypes.collection
        },
        cabins: function() {
            if (this.$store.state.cabins) {
                return this.$store.state.cabins.collection
            }
            return []
        },
        waitingCompleted: function() {
            return !this.waiting
        },
        filteredCabins: function() {},

        cruise: function() {
            return this.$store.state.cruise
        },
        payload: function() {
            return this.$store.state.payload
        },
        cabinPaxObj: function() {
            return this.$store.getters.payloadCabinPaxObj(this.cabinIndex)
        },
        cabinPaxCount: function() {
            return this.$store.getters.payloadCabinPaxCount(this.cabinIndex)
        },
        response: function() {
            return this.$store.state.response
        },
        apiData: function() {
            return this.$store.state.apiData
        },
        cabinNumbers: function() {
            return this.$store.state.cabinNumbers
        },
        kinderLeeftijden: function() {
            if (
                !this.payload ||
                !this.payload.cabins ||
                !this.payload.cabins[this.cabinIndex] ||
                !this.payload.cabins[this.cabinIndex].kinderleeftijden
            ) {
                return false
            }

            return this.payload.cabins[this.cabinIndex].kinderleeftijden
        },
    },
    watch: {
        waiting: function() {
            // reset our settings to payload values once updated through api
            this.rateCode = this.payload.rateCode
        },
    },
    methods: {
        toggleFee: function(toggle) {
          this.$store.dispatch('toggleFooi', { fooi : toggle })
          this.getData()
        },
        toggleDeckMap() {
            this.showDeckMap = !this.showDeckMap
            this.loadDeckMap()
        },
        togglePrices() {
            this.isHidden = !this.isHidden
        },
        loadDeckMap() {
            this.$store.dispatch('loadDeckMap')
        },
        isSelectedCabin(index) {
            return this.selectedId === index
        },
        selectCabin: function(cabin, apiData) {
            this.isSaved = false
            this.selectedId = cabin.id
            this.$store.dispatch('loadCabinNumberForDossier', {
                apiData: apiData,
                cabinType: cabin.type,
            })
        },

        saveSelectedCabin: function(cabin, apiData) {
            this.selectedId = cabin.id
            if (this.availabilityReceived && this.selectedId != 0) {
                this.$store.dispatch('saveCabinForDossier', {
                    apiData: apiData,
                    cabinIndex: this.cabinIndex,
                    cabinType: cabin.type,
                })
                this.message = 'Opgeslagen'
                this.isSaved = true
            }
        },
        getData: function() {
            if (!this.waiting && this.dossierID >= 0) {
                this.selectedId = 0
                this.$store.dispatch('loadCabinsForDossier', {
                    dossierID: this.dossierID,
                    cabinIndex: this.cabinIndex,
                    rateCode: this.rateCode,
                })
            }
        },
        prijsPP: function(prijs) {
            if (prijs > 0 && this.cabinPaxCount > 0) {
                return Math.floor(prijs / this.cabinPaxCount)
            }
            return null
        },
    },
    mounted: function() {
        if (this.dossierID >= 0) {
            this.getData()
        } else {
            this.$router.push({ name: 'NotFound' })
        }
    },
}
</script>

<style scoped>
.succes {
    text-align: center;
    padding: 4px;

    background-color: #bbe8bb;
    margin-top: 10px;
}

.innertable td {
    width: 200px;
    display: inline-block;
    white-space: nowrap;
}

tr {
    text-align: left;
}

tr.border_bottom th {
    border-bottom: 1pt solid lightgrey;
}
.table {
    width: 100%;
}
table td {
    width: auto;
}
.mainbox {
    height: 384px;
    overflow: auto;
    padding: 8px;
}
</style>
